import React from 'react';

import { WorkflowRunCommandName } from '@dashboard/generated/wp/platform';

import BaseCommandButton from './BaseCommandButton';

type Props = {
  workflowRunId: string;
};

export default function CancelWorkflowRunButton({ workflowRunId }: Props) {
  return (
    <BaseCommandButton
      workflowRunId={workflowRunId}
      commandName={WorkflowRunCommandName.Cancel}
      title="Cancel workflow?"
      description="Canceling will stop the workflow and prevent it from finishing any remaining steps."
      buttonText="Cancel workflow"
      confirmButtonLabel="Yes, cancel workflow"
    />
  );
}
